// Alle import-setninger øverst i filen:
import b1 from "../assets/images/benk/b1.webp";
import b2 from "../assets/images/benk/b2.webp";
import b3 from "../assets/images/benk/b3.webp";
import b4 from "../assets/images/benk/b4.webp";
import b5 from "../assets/images/benk/b5.webp";
import b6 from "../assets/images/benk/b6.webp";
import b7 from "../assets/images/benk/b7.webp";

import f1 from "../assets/images/flip/f1.webp";
import f2 from "../assets/images/flip/f2.webp";
import f3 from "../assets/images/flip/f3.webp";
import f4 from "../assets/images/flip/f4.webp";
import f5 from "../assets/images/flip/f5.webp";
import f6 from "../assets/images/flip/f6.webp";
import f7 from "../assets/images/flip/f7.webp";
import f8 from "../assets/images/flip/f8.webp";
import f9 from "../assets/images/flip/f9.webp";
import f10 from "../assets/images/flip/f10.webp";
import f11 from "../assets/images/flip/f11.webp";

import ss1 from "../assets/images/stool/s1.webp";
import ss2 from "../assets/images/stool/s2.webp";
import ss3 from "../assets/images/stool/s3.webp";
import ss4 from "../assets/images/stool/s4.webp";
import ss5 from "../assets/images/stool/s5.webp";
import ss6 from "../assets/images/stool/s6.webp";
import ss7 from "../assets/images/stool/s7.webp";

import roundtableImage from "../assets/images/rt/roundtable.webp";
import coffetableImage from "../assets/images/coffetable/coffetable.webp";

import fj1 from "../assets/images/fjol/fj1.webp";
import fj2 from "../assets/images/fjol/fj2.webp";
import fj3 from "../assets/images/fjol/fj3.webp";
import fj4 from "../assets/images/fjol/fj4.webp";
import fj5 from "../assets/images/fjol/fj5.webp";

import lrt1 from "../assets/images/rt/r1.webp";
import lrt2 from "../assets/images/rt/r2.webp";
import lrt3 from "../assets/images/rt/r3.webp";
import lrt4 from "../assets/images/rt/r4.webp";
import lrt5 from "../assets/images/rt/r5.webp";
import lrt6 from "../assets/images/rt/r6.webp";

import rmovie from "../assets/video/rmovie.mp4";
import rturn from "../assets/video/roundtable.mp4";

import rt1 from "../assets/images/roundtable/rt1.webp";
import rt2 from "../assets/images/roundtable/rt2.webp";
import rt3 from "../assets/images/roundtable/rt3.webp";
import rt4 from "../assets/images/roundtable/rt4.webp";
import rt5 from "../assets/images/roundtable/rt5.webp";
import rt6 from "../assets/images/roundtable/rt6.webp";
import rt7 from "../assets/images/roundtable/rt7.webp";
import rt8 from "../assets/images/roundtable/rt8.webp";

import t1 from "../assets/images/tvstand/t1.webp";
import t2 from "../assets/images/tvstand/t2.webp";
import t3 from "../assets/images/tvstand/t3.webp";
import t4 from "../assets/images/tvstand/t4.webp";
import t5 from "../assets/images/tvstand/t5.webp";
import t6 from "../assets/images/tvstand/t6.webp";
import t7 from "../assets/images/tvstand/t7.webp";
import t8 from "../assets/images/tvstand/t8.webp";
import t9 from "../assets/images/tvstand/t9.webp";
import t10 from "../assets/images/tvstand/t10.webp";
import t11 from "../assets/images/tvstand/t11.webp";
import t12 from "../assets/images/tvstand/t12.webp";
import t13 from "../assets/images/tvstand/t13.webp";

import n1 from "../assets/images/nattbord/n1.webp";
import n2 from "../assets/images/nattbord/n2.webp";
import n3 from "../assets/images/nattbord/n3.webp";
import n4 from "../assets/images/nattbord/n4.webp";
import n5 from "../assets/images/nattbord/n5.webp";
import n6 from "../assets/images/nattbord/n6.webp";
import n7 from "../assets/images/nattbord/n7.webp";
import n8 from "../assets/images/nattbord/n8.webp";
import n9 from "../assets/images/nattbord/n9.webp";
import n10 from "../assets/images/nattbord/n10.webp";
import n11 from "../assets/images/nattbord/n11.webp";
import n12 from "../assets/images/nattbord/n12.webp";
import n13 from "../assets/images/nattbord/n13.webp";

import s1 from "../assets/images/spisestuebord/s1.webp";
import s2 from "../assets/images/spisestuebord/s2.webp";
import s3 from "../assets/images/spisestuebord/s3.webp";
import s4 from "../assets/images/spisestuebord/s4.webp";
import s5 from "../assets/images/spisestuebord/s5.webp";
import s6 from "../assets/images/spisestuebord/s6.webp";
import s7 from "../assets/images/spisestuebord/s7.webp";
import s8 from "../assets/images/spisestuebord/s8.webp";
import s9 from "../assets/images/spisestuebord/s9.webp";
import s10 from "../assets/images/spisestuebord/s10.webp";
import s11 from "../assets/images/spisestuebord/s11.webp";
import s12 from "../assets/images/spisestuebord/s12.webp";
import s13 from "../assets/images/spisestuebord/s13.webp";
import s14 from "../assets/images/spisestuebord/s14.webp";
import s15 from "../assets/images/spisestuebord/s15.webp";
import s16 from "../assets/images/spisestuebord/s16.webp";
import s17 from "../assets/images/spisestuebord/s17.webp";
import s18 from "../assets/images/spisestuebord/s18.webp";

import lr0016 from "../assets/images/swing/lr0016.webp";
import lr0015 from "../assets/images/swing/lr0015.webp";
import lr0014 from "../assets/images/swing/lr0014.webp";
import lr0013 from "../assets/images/swing/lr0013.webp";
import lr0012 from "../assets/images/swing/lr0012.webp";
import lr0011 from "../assets/images/swing/lr0011.webp";
import lr0010 from "../assets/images/swing/lr0010.webp";
import lr0009 from "../assets/images/swing/lr0009.webp";
import lr0008 from "../assets/images/swing/lr0008.webp";
import lr0007 from "../assets/images/swing/lr0007.webp";
import lr0006 from "../assets/images/swing/lr0006.webp";
import lr0005 from "../assets/images/swing/lr0005.webp";
import lr0004 from "../assets/images/swing/lr0004.webp";
import lr0003 from "../assets/images/swing/lr0003.webp";
import lr0002 from "../assets/images/swing/lr0002.webp";
import lr0001 from "../assets/images/swing/lr0001.webp";

// Deretter organiserer vi og eksporterer assetene etter kategori:

// --- Benk-bilder ---
export const benk = { b1, b2, b3, b4, b5, b6, b7 };

// --- Flip-bilder ---
export const flip = { f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11 };

// --- Stool-bilder ---
export const stool = { ss1, ss2, ss3, ss4, ss5, ss6, ss7 };

// --- Roundtable ---
export const roundtable = { roundtableImage };

// --- Coffetable ---
export const coffetable = { coffetableImage };

// --- Fjol-bilder ---
export const fjol = { fj1, fj2, fj3, fj4, fj5 };

// --- Roundtable-bilder (tillegg) ---
export const roundtableImages = { lrt1, lrt2, lrt3, lrt4, lrt5, lrt6 };

// --- Ekstra Roundtable ---
export const roundtableExtra = { rt1, rt2, rt3, rt4, rt5, rt6, rt7, rt8 };

// --- Tvstand-bilder ---
export const tvstand = { t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13 };

// --- Nattbord-bilder ---
export const nattbord = { n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12, n13 };

// --- Spisestuebord-bilder ---
export const spisestuebord = { s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18 };

// --- 
export const swing = { lr0016,lr0015,lr0014,lr0013,lr0012,lr0011,lr0010,lr0009,lr0008,lr0007,lr0006,lr0005,lr0004,lr0003,lr0002,lr0001 };

// --- Video-assets ---
export const videos = { rmovie, rturn };

// Eksporter alt samlet som standard:
const assetsCollection = {
    benk,
    flip,
    stool,
    roundtable,
    coffetable,
    fjol,
    roundtableImages,
    roundtableExtra,
    tvstand,
    nattbord,
    spisestuebord,
    swing,
    videos,
  };
  
  export default assetsCollection;